<script>
import Loader from "./Loader";
import Hourly from "./Hourly";
import weatherIcon from "../weatherIcon";

export default {
  name: "Location",
  components: {
    loader: Loader,
    hourly: Hourly,
  },
  data() {
    return {
      contants: [
        {
          name: "Feels",
          id: "feels_like",
          unit: "°C",
        },
        {
          name: "Clouds",
          id: "clouds",
          unit: "%",
        },
        {
          name: "Pressure",
          id: "pressure",
          unit: "hPa",
        },
        {
          name: "Humidity",
          id: "humidity",
          unit: "%",
        },
        {
          name: "Wind",
          id: "wind_speed",
          unit: "m/s",
        },
        /* {
          name: "Visibility",
          id: "visibility",
          unit: "m",
        }, */
        {
          name: "Dew point",
          id: "dew_point",
          unit: "°C",
        },
      ],
    };
  },
  props: {
    loc: Object,
    index: Number,
    active: Boolean,
  },
  methods: {
    remove() {
      this.$store.commit("removeLoc", this.index);
    },
    formatHour(dt) {
      const d = new Date(dt * 1000);
      return (
        (d.getHours() < 10 ? "0" + d.getHours() : d.getHours()) +
        "h" +
        (d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes())
      );
    },
  },
  computed: {
    icon() {
      return weatherIcon(this.loc.weather.current.weather[0].id);
    },
  },
};
</script>
<template>
  <div class="location">
    <template v-if="loc.loaded">
      <header>
        <div class="city">{{ loc.text }},</div>
        <div class="country">
          {{ loc.context.map((c) => c.text).join(", ") }}
        </div>
      </header>

      <!-- principal -->
      <section class="principal">
        <img :src="icon" alt="Weather icon" class="icon" />
        <div class="infos">
          <div class="temp">
            <span class="value">{{ loc.weather.current.temp.toFixed(1) }}</span
            ><span class="unit">°C</span>
          </div>
          <div class="desc">
            {{ loc.weather.current.weather[0].description }}
          </div>
        </div>
      </section>

      <!-- Rain -->
      <div v-if="loc.weather.current.rain" class="rain">
        <img src="../assets/icons/umbrella.svg" alt="Icon" class="icon" />
        <div class="name">Rain</div>
        <div class="data">
          <span class="value">{{ loc.weather.current.rain["1h"] }}</span>
          <span class="unit">mm/h</span>
        </div>
      </div>

      <!-- constants -->
      <section class="constants">
        <div v-for="c in contants" :key="c.id" class="constant">
          <img
            :src="require('../assets/icons/constants/' + c.id + '.svg')"
            alt="Icon"
            class="icon"
          />
          <div class="name">{{ c.name }}</div>
          <div class="data">
            <span class="value">{{ loc.weather.current[c.id] }}</span>
            <span class="unit"> {{ c.unit }}</span>
          </div>
        </div>
      </section>

      <!-- sun -->
      <section class="sun">
        <div class="constant">
          <img
            src="../assets/icons/constants/sunrise.svg"
            alt="Icon"
            class="icon"
          />
          <div class="name">Sunrise</div>
          <div class="data">
            <span class="value">{{
              formatHour(loc.weather.current.sunrise)
            }}</span>
          </div>
        </div>
        <div class="constant">
          <img
            src="../assets/icons/constants/sunset.svg"
            alt="Icon"
            class="icon"
          />
          <div class="name">Sunset</div>
          <div class="data">
            <span class="value">{{
              formatHour(loc.weather.current.sunset)
            }}</span>
          </div>
        </div>
      </section>

      <!-- hourly -->
      <hourly :loc="loc" />

      <!-- footer -->
      <footer>
        <div class="update">
          Updated at
          {{ new Date(loc.weather.current.dt * 1000).toLocaleString("en") }}
        </div>
        <button class="btn grave" @click="remove">Remove location</button>
      </footer>
    </template>
    <div v-else class="center">
      <loader />
    </div>
  </div>
</template>
<style lang="scss">
.location {
  .center {
    padding: 1rem;
  }

  header {
    margin: 20px;
    font-weight: bold;

    .city {
      font-size: 36px;
    }

    .country {
      font-size: 20px;
      color: var(--light-color);
    }
  }

  .principal {
    margin: 3rem 1rem;
    display: flex;
    justify-content: center;
    align-items: center;

    .icon {
      display: block;
      height: 100px;
      width: 100px;
      object-fit: contain;
      object-position: center;
    }

    .infos {
      margin-left: 10px;

      .temp {
        display: flex;

        .value {
          font-size: 48px;
          font-weight: bold;
        }

        .unit {
          font-size: 24px;
          font-weight: bold;
          color: var(--light-color);
          margin-top: 5px;
        }
      }

      .desc {
        font-size: 24px;
        font-weight: bold;
        max-width: 150px;
      }
    }
  }

  div.rain {
    width: 100%;

    .icon {
      height: 2rem;
    }

    .name {
      font-size: 1.2rem;
    }

    .data .value {
      font-size: 2rem;
    }
  }

  .constants {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }

  .sun {
    margin-top: 1rem;
    display: flex;
    justify-content: space-around;
  }

  .constant,
  .rain {
    margin-bottom: 1rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 33%;

    .icon {
      height: 1.5rem;
    }

    .name {
      font-size: 0.8rem;
    }

    .data {
      margin-top: 0.5rem;

      .value {
        font-size: 1.2rem;
        font-weight: bold;
      }

      .unit {
        font-size: 1rem;
        color: var(--light-color);
      }
    }
  }

  footer {
    margin-top: 1rem;

    .update {
      margin: 0 1rem;
      font-size: 0.8rem;
      color: var(--light-color);
    }
  }
}
</style>